/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import FormItem from '@ion/dls/src/components/forms/FormItem';
import FormTextField from '@ion/dls/src/components/forms/FormTextField';
import {PegFieldProps} from '../../types';

/**
 * Defines the `PegTextField` component, which renders a text field
 * for displaying and managing string parameters.
 * 
 * ```typescript
 * 
 *    <PegTextField 
 *      fieldLabel={label}
 *      value={value}
 *      onChange={function(){}} />
 * 
 * ```
 */
const PegTextField = ({label, value, onChange}: PegFieldProps) => (
  <FormItem>
    <FormTextField fieldLabel={label}
      value={value as string}
      onChange={function({target: {value: v}}) {
        onChange(v);
      }} />
  </FormItem>
);

export {PegTextField};
